import React from "react";
import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  Spinner,
  useToast,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  useDisclosure,
} from "@chakra-ui/react";

import ConfirmationModal from "./ConfirmationModal";
import useKWCSendBag from "api/mutations/useKWCSendBag";
import { useUserContext } from "context/UserContext";

const SummaryModal = ({ isOpen, onClose, formik, sentBags }) => {
  const { user } = useUserContext();
  const toast = useToast();
  const {
    isOpen: isConfirmModalOpen,
    onOpen: onConfirmModalOpen,
    onClose: onConfirmModalClose,
  } = useDisclosure();

  const sendBagMutation = useKWCSendBag({
    onSuccess: () => {
      onConfirmModalOpen();
    },
    onError: (err) => {
      toast({
        title: "Failed to send bag",
        description:
          "An error occurred while sending the bag. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      onClose();
    },
  });
  console.log("Formik Summary", formik);
  const handleSubmit = () => {
    const data = {
      requested_by: user?.info?._id || formik?.values?.requested_by,
      // noOfItems: formik?.values?.noOfItems,
      bagIds: formik?.values?.bagIds,
      locationId: formik?.values?.location?._id,
    };
    sendBagMutation.mutate(data);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={4}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            Send Bag Summary
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansMedium"
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              Bag IDs:
            </Text>
            <Text
              color="#000000"
              fontFamily="PlusJakartaSansRegular"
              fontSize="12px"
            >
              {formik?.values?.bagIds
                ?.map((id) => {
                  const bag = sentBags?.find((b) => b._id === id);
                  return bag ? bag.id : id; // show readable bag.id if found
                })
                .join(", ")}
            </Text>
          </Box>
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansMedium"
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              Drop-off Location:
            </Text>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansRegular"
              fontSize={"12px"}
            >
              {formik?.values.location?.name}
              {", "}
              {formik?.values.location?.postcode}
            </Text>
          </Box>
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansMedium"
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              Terms & Conditions
            </Text>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansRegular"
              fontSize={"12px"}
            >
              By clicking Accept and Continue – I accept DHL's{" "}
              <Text
                as="span"
                href="#"
                color="#456EFF"
                textDecoration="underline"
                cursor={"pointer"}
              >
                Terms and Conditions
              </Text>
              , and declare that this shipment does not include any{" "}
              <Text
                as="span"
                href="#"
                color="#456EFF"
                textDecoration="underline"
                cursor={"pointer"}
              >
                Prohibited Items
              </Text>
              .
            </Text>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"225px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={() => {
                handleSubmit();
              }}
            >
              {sendBagMutation?.isLoading ? <Spinner /> : "  ACCEPT & CONTINUE"}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
      <ConfirmationModal
        onCloseSummaryModal={onClose}
        onClose={onConfirmModalClose}
        isOpen={isConfirmModalOpen}
        location={formik.values.location}
      />
    </Modal>
  );
};

export default SummaryModal;
